<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.fromDate') }}</div>
                <CalendarSelect
                  v-model="searchParams.dateFrom"
                  :disabled="disableDate"
                  mode="date"
                  @input="onChangeDateFrom"
                />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.toDate') }}</div>
                <CalendarSelect
                  v-model="searchParams.dateTo"
                  :disabled="disableDate"
                  mode="date"
                  @input="onChangeDateTo"
                />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div
                class="das-form-input"
                style="position: absolute; z-index: 1000; width: 400px"
              >
                <div class="label">{{ $t('field.bookingGroup') }}</div>
                <select-with-search-table
                  style="width: 100%; z-index: 10000"
                  index-field="id"
                  :selected-index-field-value="searchParams.bookingGroupId"
                  :rows="bookingGroupOptions"
                  :columns="bookingGroupOptionsCols"
                  :value="searchParams.bookingGroupId"
                  :is-remove-btn="true"
                  :dropdown-width="450"
                  @selectionChanged="onSelectBookingGroup"
                >
                  <template v-slot:value="{ selectedValue: selectedData }">
                    {{ selectedData?.name }}
                  </template>
                </select-with-search-table>
                <!-- <el-select
                  v-model="searchParams.bookingGroupId"
                  filterable
                  placeholder=""
                >
                  <el-option
                    v-for="item in bookingGroupOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">
                {{ $t('views.report.groupGuestReport') }}
              </span>
            </div>
            <div class="flex" style="gap: 10px">
              <InfoBtn @click="noteDialogVisible = true" />

              <el-dropdown trigger="click" @command="onClickDropdownItem">
                <das-button
                  color="primary"
                  size="medium"
                  :rounded="false"
                  outline
                  icon
                >
                  <i class="el-icon-download"></i>
                </das-button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">
                    {{ $t('button.exportPdf') }}
                  </el-dropdown-item>
                  <el-dropdown-item command="excel">
                    {{ $t('button.exportExcel') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <hr />

          <div class="w-full">
            <el-table
              class="report-table overflow-auto"
              :height="'700px'"
              :data="rows"
              :border="true"
              :span-method="objectSpanMethod"
            >
              <el-table-column
                v-for="(item, index) in columns"
                :key="index"
                :prop="item.field"
                :label="item.headerName"
                :min-width="item?.minWidth || 100"
                :header-align="'left'"
                :align="item.cellClass === 'ag-cell-right' ? 'right' : null"
                :formatter="
                  formatNumberField.includes(item.field) ? displayNumber : null
                "
              >
                <template
                  v-if="item.field === 'payment_status'"
                  #default="scope"
                >
                  <span v-if="scope.row.payment_status === 1" class="">{{
                    'Đã thanh toán'
                  }}</span>
                  <span v-else-if="scope.row.payment_status === 2" class="">{{
                    'Trừ vào công nợ'
                  }}</span>
                  <span v-else class="">{{ 'Chưa thanh toán' }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :auto-size-cell="true"
              :auto-select-first-row="false"
              :suppress-row-transform="true"
              row-selection="false"
              dom-layout="scroll"
            />
          </div> -->
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('dialog.titleNote')"
      :visible.sync="noteDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Recode: Mã đặt phòng</li>
            <li>Số phòng: Số phòng chi tiết</li>
            <li>Hạng phòng: Hạng phòng của phòng</li>
            <li>Mã giá: Mã giá áp dụng cho phòng</li>
            <li>Giá phòng: Hiển thị giá phòng theo Mã giá</li>
            <li>Tên khách: Tên khách chính của phòng</li>
            <li>Ngày đến: ngày đến của phòng</li>
            <li>Ngày đi: Ngày đi của phòng</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="noteDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DasButton from '@/components/ui/DasButton.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import Multiselect from 'vue-multiselect'
import { getAllHotel } from '@/api/hotel.js'
import { getBookingGroupListApi } from '@/api/booking_service/bookingGroupApi'
import {
  getBookingGroupReportApi,
  getBookingGroupReportExcel
} from '@/api/report_service/report'
import InfoBtn from './components/InfoBtn.vue'
import { DEFAULT_GRID_ROW_HEIGHT } from '@/constant'
import moment from 'moment'

const rowSpan = params => {
  if (params.data.rowSpan) {
    return params.data.rowSpan
  }

  return 1
}

const cellStyle = params => ({
  height: `${DEFAULT_GRID_ROW_HEIGHT * params.data.rowSpan}px`,
  'border-left': '1px solid #ccc',
  'border-right': '1px solid #ccc',
  'border-bottom': '1px solid #ccc',
  // 'text-wrap': 'wrap',
  top: 0,
  background: '#fff'
})
const cellStyle1 = params => ({
  'border-left': '1px solid #ccc',
  'border-right': '1px solid #ccc',
  top: 0,
  background: '#fff'
})
const getDefaultSearchParams = () => ({
  dateFrom: moment().format('YYYY-MM-DD'),
  dateTo: moment().format('YYYY-MM-DD'),
  hotelId: null,
  bookingGroupId: null
})

export default {
  components: {
    DasButton,
    CalendarSelect,
    // eslint-disable-next-line vue/no-unused-components
    Multiselect,
    InfoBtn
  },
  data() {
    return {
      disableDate: false,
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        // autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      noteDialogVisible: false,
      searchParams: getDefaultSearchParams(),
      hotelOptions: [],
      bookingGroupOptions: [],
      receptionistOptions: [],
      columns: [
        {
          // headerName: 'Kakakakakak akakakak akakakakak kakakakaka',
          headerName: this.$t('grid.column.recode'),
          field: 'booking_group_code',
          tooltipField: 'booking_group_code',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 120,
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<div style="overflow: hidden;text-overflow: ellipsis;">${params.value}</div>`
            }
          },
          cellStyle: cellStyle
        },
        {
          headerName: this.$t('grid.column.customerName'),
          field: 'traveller_name',
          tooltipField: 'traveller_name',
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<div style="overflow: hidden;text-overflow: ellipsis;">${params.value}</div>`
            }
          },
          cellStyle: cellStyle,
          // cellClass: "grid-cell-centered",
          // width: 100,
          // flex: 1,
          sortable: false,
          minWidth: 150
        },
        {
          headerName: this.$t('grid.column.source'),
          field: 'source_name',
          tooltipField: 'source_name',

          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 120,
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<div style="overflow: hidden;text-overflow: ellipsis;">${params.value}</div>`
            }
          },
          cellStyle: cellStyle
        },
        {
          headerName: this.$t('grid.column.comeDate'),
          field: 'arrive_date',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          cellStyle: cellStyle1,
          minWidth: 130,
          maxWidth: 130
        },
        {
          headerName: this.$t('grid.column.departDate'),
          field: 'depart_date',
          cellStyle: cellStyle1,

          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 130,
          maxWidth: 130
        },
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'room_level',
          tooltipField: 'room_level',

          cellStyle: cellStyle1,

          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 150
        },
        {
          headerName: this.$t('grid.column.hotel'),
          field: 'hotel_name',
          cellStyle: cellStyle1,
          tooltipField: 'hotel_name',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 150,
          flex: 1
        },
        {
          headerName: this.$t('grid.column.roomPrice'),
          field: 'price',
          cellStyle: cellStyle1,
          tooltipValueGetter: params => {
            return this.$displayCurrency(params.data.price)
          },
          valueGetter: params => {
            return this.$displayCurrency(params.data.price)
          },
          // cellClass: "grid-cell-centered",
          // width: 100,
          cellClass: 'ag-cell-right',
          sortable: false,
          minWidth: 120
        },
        {
          headerName: this.$t('grid.column.discount'),
          field: 'total_discount',
          tooltipValueGetter: params => {
            return this.$displayCurrency(params.data.total_discount)
          },
          valueGetter: params => {
            return this.$displayCurrency(params.data.total_discount)
          },
          cellStyle: cellStyle1,

          // cellClass: "grid-cell-centered",
          // width: 100,
          cellClass: 'ag-cell-right',
          sortable: false,
          minWidth: 120
        },
        {
          headerName: this.$t('grid.column.quantity'),
          field: 'num_of_rooms',
          cellStyle: cellStyle1,

          // cellClass: "grid-cell-centered",
          // width: 100,
          cellClass: 'ag-cell-right',
          sortable: false,
          minWidth: 90,
          maxWidth: 100
        },
        {
          headerName: this.$t('grid.column.revenueOfOtherSerivces'),
          field: 'other_price',
          tooltipValueGetter: params => {
            return this.$displayCurrency(params.data.other_price)
          },
          valueGetter: params => {
            return this.$displayCurrency(params.data.other_price)
          },
          cellStyle: cellStyle1,

          // cellClass: "grid-cell-centered",
          // width: 100,
          cellClass: 'ag-cell-right',
          sortable: false,
          minWidth: 120
        },
        {
          headerName: this.$t('grid.column.totalAmount'),
          field: 'total',
          cellStyle: cellStyle1,
          tooltipValueGetter: params => {
            return this.$displayCurrency(params.data.total)
          },
          valueGetter: params => {
            return this.$displayCurrency(params.data.total)
          },
          // cellClass: "grid-cell-centered",
          // width: 100,
          cellClass: 'ag-cell-right',
          sortable: false,
          minWidth: 150
        },

        {
          headerName: this.$t('grid.column.paymentStatus'),
          field: 'payment_status',
          rowSpan: rowSpan,

          cellStyle: cellStyle,
          valueGetter: params => {
            if (params.data.payment_status === 1) {
              return 'Đã thanh toán'
            } else if (params.data.payment_status === 2) {
              return 'Trừ vào công nợ'
            } else {
              return 'Chưa thanh toán'
            }
          },
          tooltipValueGetter: params => {
            if (params.data.payment_status === 1) {
              return 'Đã thanh toán'
            } else if (params.data.payment_status === 2) {
              return 'Trừ vào công nợ'
            } else {
              return 'Chưa thanh toán'
            }
          }, // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 150
        }
      ],
      rows: [],

      bookingGroupOptionsCols: [
        {
          headerName: 'Mã đoàn',
          field: 'booking_code',
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: 'Tên đoàn',
          field: 'name',
          // cellClass: "grid-cell-centered",
          flex: 1,
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Tên khách',
          field: 'traveller_name',
          // cellClass: "grid-cell-centered",

          minWidth: 100,
          maxWidth: 150
        }
      ],
      formatNumberField: [
        'price',
        'total_discount',
        'num_of_rooms',
        'other_price',
        'total'
      ]
    }
  },
  // watch: {
  //   'searchParams.bookingGroupId': {
  //     handler(value) {
  //       // console.log(value)
  //       if (value !== undefined) {
  //         console.log('check varr')
  //         this.disableDate = true
  //         this.searchParams.dateFrom = ''
  //         this.searchParams.dateTo = ''
  //       } else {
  //         this.disableDate = false
  //         console.log(1232)
  //         // this.searchParams = getDefaultSearchParams()
  //       }
  //     },
  //     deep: true
  //   }
  // },
  async created() {
    await Promise.all([this.getHotelOptions(), this.getBookingGroupOptions()])
  },
  async mounted() {
    this.attachData()
  },

  methods: {
    displayNumber(row, column, cellValue) {
      // console.log('rowwww2,', row, cellValue)
      return this.$displayCurrency(cellValue)
    },
    objectSpanMethod(data) {
      // 0 1 2 12
      if (data.columnIndex <= 2 || data.columnIndex === 12) {
        if (data.row.rowSpan !== undefined) {
          return {
            rowspan: data.row.rowSpan,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    checkValidDateRange(dateFrom, dateTo) {
      if (dateFrom && dateTo && dateFrom > dateTo) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.fromDateMustEarlierThanToDate')
        })
        return false
      }
      return true
    },

    onChangeDateFrom(date) {
      this.searchParams.dateFrom = date
      if (!this.checkValidDateRange(date, this.searchParams.dateTo)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    onChangeDateTo(date) {
      this.searchParams.dateTo = date
      if (!this.checkValidDateRange(this.searchParams.dateFrom, date)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    // SELECT OPTIONS
    async getHotelOptions() {
      await getAllHotel().then(res => {
        this.hotelOptions = res.data
      })
    },
    async getBookingGroupOptions() {
      await getBookingGroupListApi({
        isRoomBooking: true,
        isRoomCo: true,
        isCancel: true,
        isRoomCi: true
      }).then(res => {
        this.bookingGroupOptions = res.data
      })
    },

    async onSelectBookingGroup(data) {
      // this.searchParams.bookingGroupId = data?.id
      if (data != null) {
        this.searchParams.dateFrom = null
        this.searchParams.dateTo = null
        this.searchParams.bookingGroupId = await data?.id
        this.disableDate = true
      } else {
        this.disableDate = false
        this.searchParams = getDefaultSearchParams()
      }
    },

    onSearch() {
      this.attachData()
    },
    onReset() {
      this.searchParams = getDefaultSearchParams()
      this.attachData()
    },
    onClickDropdownItem(cmd) {
      if (cmd === 'excel') {
        getBookingGroupReportExcel(this.searchParams).then(res => {
          if (res) {
            const date = this.$moment().format('DD-MM-YYYY')
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'group_guest_report_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
      }
    },
    async attachData() {
      await getBookingGroupReportApi(this.searchParams).then(res => {
        this.rows = this.convertRowData(res.data)
        // res.data.
      })
    },
    convertRowData(rows) {
      let newRowData = []
      rows.forEach(item => {
        if (item.room_booking_groups?.[0]) {
          item.room_booking_groups[0] = {
            ...item.room_booking_groups[0],
            source_name: item.source_name,
            booking_group_code: item.booking_group_code,
            rowSpan: item.room_booking_groups.length,
            payment_status: item.payment_status
          }
          newRowData = [...newRowData, ...item.room_booking_groups]
        }
      })
      // console.log(newRowData)
      return newRowData
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 40
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    }
  }
}
</script>

<style></style>
